import { useMemo } from 'react';

import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { GridColDef } from '@mui/x-data-grid-pro';

import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';

import { CostCenter } from 'components/admin-portal/Procedures/Reports/type';

const useColumnDefinitions = (costCenters: CostCenter[]) => {
  const { t } = useTranslation('common');

  return useMemo(() => columnDefinitions(t, costCenters), [t]);
};

const columnDefinitions = (t: TFunction, costCenters: CostCenter[]) => {
  if (!costCenters) {
    return [];
  }

  return [
    {
      field: 'brNames',
      headerName: t('dataPermissions.planUnit'),
      flex: true,
      valueGetter: (_, row: CostCenter) => {
        const currentCostCenterNames = costCenters
          .filter((costCenter) => costCenter.brId === row.brId)
          .map((costCenter) => costCenter.name);

        if (row.brId === -1) {
          return t('allPlanUnits');
        }

        return currentCostCenterNames.join();
      }
    },
    {
      field: 'approveHours',
      type: 'boolean',
      headerName: t('dataPermissions.approveHours'),
      renderCell: ({ value }) => <BooleanCell value={value} />
    }
  ] as GridColDef[];
};

export default useColumnDefinitions;
